import {
  CrudBuilderState,
  didError,
  didSucceed,
  getFetchSlice,
  hasStarted
} from "seneca-common/utils/apiStates";

type State = CrudBuilderState;

function getContentStatsFetchStateSlice(state: State, courseId: string) {
  const fetchSlice = getFetchSlice(state);
  return fetchSlice && fetchSlice.get(courseId);
}

export function allContentStatsForCourseFetching(
  state: State,
  courseId: string
): boolean {
  const meta = getContentStatsFetchStateSlice(state, courseId);
  return !!meta && hasStarted(meta);
}

export function allContentStatsForCourseFetchSucceeded(
  state: State,
  courseId: string
) {
  const meta = getContentStatsFetchStateSlice(state, courseId);
  return !!meta && didSucceed(meta);
}

export function allContentStatsForCourseFetchErrored(
  state: State,
  courseId: string
) {
  const meta = getContentStatsFetchStateSlice(state, courseId);
  return !!meta && didError(meta);
}

export function allContentStatsForCourseFetchFinished(
  state: State,
  courseId: string
) {
  return (
    allContentStatsForCourseFetchSucceeded(state, courseId) ||
    allContentStatsForCourseFetchErrored(state, courseId)
  );
}

export function allContentStatsForCourseNeedsFetching(
  state: State,
  courseId: string
) {
  return !(
    allContentStatsForCourseFetchSucceeded(state, courseId) ||
    allContentStatsForCourseFetching(state, courseId)
  );
}
